/**
 * Column class
 * @private
 */
var Column = /** @class */ (function () {
    function Column() {
    }
    return Column;
}());
export { Column };
